/// <reference types="vite-plugin-svgr/client" />

import { render } from "react-dom"
import "rsuite/styles/common.less"
import "rsuite/DatePicker/styles/index.css"
import "rsuite/DateRangePicker/styles/index.css"
import "./index.css"
import RNB from "./RNB"
import { initDatadogRum } from "./datadogRum"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import configureStore from "./store/store.config"
import "react-toastify/dist/ReactToastify.css"
import { BrowserRouter } from "react-router-dom"

if (!import.meta.env.DEV) {
  initDatadogRum()
}

const store = configureStore()

const renderApp = () =>
  render(
    <BrowserRouter basename="/rnb">
      <Provider store={store}>
        <RNB />
      </Provider>
    </BrowserRouter>,
    document.getElementById("root")
  )

renderApp()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
